import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { ColorNeutralBlack, ColorNeutralDarkGrey, FontWeightNormal, Spacing8 } from 'autogen/design-tokens/tokens';
import { PossibleAdditionalDeliveryCost } from 'autogen/translation-keys/trans-website-shared-productitem';
import PriceLabel from 'components/generic/PriceModule/components/PriceLabelRenderer';
import { Typography } from 'components/generic/typography';
import Price from './Price';
import fontSizeDecreaser from './shared/fontSizeDecreaser';
import type { HorizontalPriceModuleType } from './shared/types';

// #region Style
const Wrapper = styled.div``;

const ChanelPriceLabelRenderer = styled(PriceLabel)`
    div {
        color: ${ColorNeutralBlack};
    }
`;

const ChanelStyledPrice = styled(Price)<{ $isOnDiscount?: boolean }>`
    color: ${ColorNeutralBlack};
    font-weight: 600;

    ${({ $isOnDiscount }) =>
        $isOnDiscount &&
        css`
            color: ${ColorNeutralBlack};
        `}
`;

const ChanelStyledPriceBefore = styled(Price)`
    font-weight: ${FontWeightNormal};
    color: ${ColorNeutralDarkGrey};
    text-decoration: line-through;
    line-height: normal;
    margin-left: ${Spacing8};
`;

const AdditionalDeliveryCost = styled(Typography.Body)`
    color: ${ColorNeutralDarkGrey};
`;
// #endregion Style

export default function ChanelHorizontalPriceModule({
    isOnDiscount = false,
    price,
    priceBefore,
    priceSaving,
    showPossibleAdditionalDeliveryCost,
    size = 18,
    priceLabel,
    ...restProps
}: HorizontalPriceModuleType): JSX.Element {
    const { t } = useTranslation();

    /* Top Title */
    const getPriceTopTitle = () => {
        if (priceLabel) {
            return <ChanelPriceLabelRenderer size="sm" priceLabel={priceLabel} />;
        }

        return null;
    };

    /* Price */
    const getPrice = () => (
        <div>
            <ChanelStyledPrice $isOnDiscount={isOnDiscount} price={price} size={size} />
            {isOnDiscount && priceBefore && (
                <ChanelStyledPriceBefore price={priceBefore} size={fontSizeDecreaser(size, 4)} />
            )}
        </div>
    );
    return (
        <Wrapper {...restProps}>
            {getPriceTopTitle()}
            {getPrice()}
            {showPossibleAdditionalDeliveryCost && (
                <AdditionalDeliveryCost>{t(PossibleAdditionalDeliveryCost)}</AdditionalDeliveryCost>
            )}
        </Wrapper>
    );
}
